module.exports = __webpack_public_path__ + "static/Girl with Medication-2400547e5be8e83c93ab408e86ab2dae.jpg";